export const CLIENT_DATA_MOCK = {
  companyName: "Sklep spożywczy KARKULKA",
  nip: "098-765-4321",
  master: false,
};
export const CLIENTS_DATA_MOCK = {
  result: [
    {
      companyName: "Fabryka mechanicznych części do samochodów",
      nip: "123-456-7890",
      master: false,
    },
    {
      companyName: "Galeria handlowa URATON",
      nip: "098-765-4321",
      master: false,
    },
    {
      companyName: "Sklep spożywczy KARKULKA",
      nip: "098-765-4321",
      master: false,
    },
    {
      companyName: "Hurtownia MANAT",
      nip: "098-765-4321",
      master: false,
    },
    {
      companyName: "Client 5",
      nip: "098-765-4321",
      master: false,
    },
  ],
};
